module.exports = __webpack_public_path__ + "static/hero-778e360495f56236c22541350f396b54.jpg";